import { Component, OnInit } from '@angular/core';
import { NavBarService } from '../../../services/nav-bar.service';
import { IconBarService } from '../../../services/icon-bar.service';
import { MenuService } from '../../../services/menu.service';
import { DataIoService } from '../../../services/data-io.service';
import { MenuNode } from '../../../classes';
import { EnabledNodesPipe } from '../../../pipes/enabled-nodes.pipe';

@Component({
  selector: 'app-inline-menu',
  templateUrl: './inline-menu.component.html',
  styleUrls: ['./inline-menu.component.scss']
})
export class InlineMenuComponent implements OnInit {
	node : MenuNode = undefined;
  currentElement : MenuNode = undefined;
  menuElements : Array<MenuNode> = undefined;
	smallLetters : string="";
	bigLetters : string="";

	_gated:boolean=false;
  constructor(
  	private navBar:NavBarService,
  	private iconBar:IconBarService,
  	private menuService:MenuService,
  	private ioService:DataIoService,
    private enabledNodes: EnabledNodesPipe
  ) { }
  b():string{
    if(this._firstLetterState){
  	  return this.bigLetters;
    }else{
      if(this.bigLetters){
        if(this.bigLetters.length >= 4){
          return ' '+this.bigLetters.charAt(1)+this.bigLetters.charAt(2)+this.bigLetters.charAt(3);
        }
      }
    }
  }
  unit():string{
  	if(this.currentElement.getUnit()){
	  return this.currentElement.getUnit();
  	}
    
    return '';
  }
  s():string{
  	return '';
  	if(this.menuElements){
      return (this.menuElements.indexOf(this.currentElement)+1)+"'"+this.menuElements.length;
    }

  }
  getCurrentIndex():number{
    return this.menuElements.indexOf(this.currentElement);
  }
  next():void{
    let idx = this.getCurrentIndex();
    let length = this.menuElements.length;
    idx++;
    if(idx >= length){
      idx = 0;
    }
    this.setCurrentElement(this.menuElements[idx]);
  }

  previous():void{
    let idx = this.getCurrentIndex();
    let length = this.menuElements.length;
    idx--;
    if(idx < 0){
      idx = (length-1);
    }

    this.setCurrentElement(this.menuElements[(idx++)%length]);
  }







  shift(){
  	let idx = this.menuElements.indexOf(this.currentElement);
  	idx++;
  	this.setCurrentElement(this.menuElements[idx%this.menuElements.length]);
  	return;
  }

  handler(evt){
  	switch(evt){
  		case 'menu':{
  			this.shift();
        this.createString();
  			return;
      }
  		case 'confirm':{
          let targetNode = this.currentElement.getTargetNode();
			    this.menuService.goto(targetNode);
        	this.currentElement.selected = "true"
        	this.menuService.goto(this.currentElement.getTargetNode());
  			  return;
  		}
	  	case 'back':{
	        let backTarget = this.node.getBackTargetNode();
	        if(backTarget){
	          this.menuService.goto(backTarget);
	        }
	        return;
	  	}
	  	default:{
	  		return;
	  	}
  	}
  }




  hasParameter(p:string):boolean{
  	if(this.node){
  		return this.node.hasParameter(p);
  	}
  	return false;
  }
  subscription:any=undefined;
  ngOnDestroy(){
    this.customDestroy();
  }
  elements = Array<MenuNode>();

  ngOnInit() {
    console.log("Init on InlineMenu");
	  this.node = this.menuService.getCurrentNode();
    this.iconBar.saveState('onMenuInit');
    this.navBar.disableAll();
    this.navBar.enable('installer');
  	this.getMenuItems();
    this.findSelected();
  	this.subscription = this.ioService.inputs.events$.subscribe( (evt)=>{
  		this.handler(evt);
  	});
    this._blinkInterval = setInterval( () =>
                                          {
                                            this._firstLetterState = !this._firstLetterState;
                                          },400
                                      );  
    this.createString();
  }

  _blinkInterval : any = undefined;
  _firstLetterState:boolean=true;

  createString(){
  	let idx = this.menuElements.indexOf(this.currentElement);
  	let str:string = '';
  	for(let i=idx; i<idx+4;i++){
  		str+=this.menuElements[i%this.menuElements.length].getTitle();
  	}
  	this.bigLetters = str;

  }
  findSelected(){
    let selected = null;

    for(let el of this.menuElements){
        if(el.isSelected()){
            selected = el;
            if(el.selected == 'true'){
                el.selected = '';
            }
        }
        for(let subEl of el.getChilds()){
            if(subEl.isSelected()){
                selected = subEl;
                if(subEl.selected == 'true'){
                    subEl.selected = '';
                }
            }
        }
    }
    if(selected != null){
      this.setCurrentElement(selected);
    }
  }


  customDestroy(){
      //this.debug("#### OnDestroy, unsubscribing.");
      if(this.subscription){
        this.subscription.unsubscribe();
      }
      //this.debug("#### OnDestroy, unsubscribed.");
      this.subscription = null;
      this.currentElement.selected ="true";
      this.node.run((node)=>node.removeFilter(this.node.getTitle()),3);
      this.iconBar.restoreState('onMenuInit');
      clearInterval( this._blinkInterval );
  }

  getMenuItems():void{
    var _this = this;
    this.node.run(function (node) { return node.setFilter(_this.node.getTitle(), _this.enabledNodes.transform); }, 3);
    this.menuElements = this.node.getChilds();
    this.setCurrentElement(this.node.getChildByIndex(0));
  }

  setCurrentElement(node:MenuNode){
    this.currentElement = node;
    if(!this._gated){
      this.iconBar.disableAll();
    }
    let icon = this.currentElement.getIcon();
    if( icon && this.iconBar.knowsOf(icon) ){
      console.log("Icon found. Enabling icon "+icon);
      this.iconBar.enableIcon(icon);
      if(!this._gated){
        this.iconBar.enable();
      }
    }else{
      console.log("Iconbar does not know of icon "+icon);
    }
    this.ioService.infoTextAvailable(this.currentElement);
    this.createString();
  }
}
